import React from 'react';
import './Card.css'; // Ensure styles are handled in this file

const Card = ({ card, className, amountClass, iconMap }) => {
  const { name, amount } = card;

  // Get the icon based on the card name
  const icon = iconMap[name] || null;

  return (
    <div className={`card ${className}`}>
      <div className="card-header">
        <div className="card-icon">
          {icon}
        </div>
    
      </div>
      <div className="card-body">
        <div className={`card-amount ${amountClass}`}>
          {amount}
        </div>
      </div>
    </div>
  );
};

export default Card;
